import badgeIDNoQRCode from "./QRCodeLayouts/badgeIDNoQRCode";
import badgeIDNoQRCode2Lines from "./QRCodeLayouts/badgeIDNoQRCode2Lines";
import badgeIDCenterQRCode from "./QRCodeLayouts/badgeIDCenterQRCode";

export default class LabelManager {
    constructor() {
        this.labelTypes = [
            new badgeIDCenterQRCode(),
            new badgeIDCenterQRCode(false),
            badgeIDNoQRCode2Lines,
            badgeIDNoQRCode
        ];
    }
    async count() {
        return this.labelTypes.length;
    }

    async generateLabel(type, ...args) {
        return await this.labelTypes[type].generateLabel(...args);
    }

    async generateLabelSamples() {
        const samples = [];
        for (const labelType of this.labelTypes) {
            let label = await labelType.generateLabel("0123", "LNUM", "HNUM", 480, 620, false)
            let blobUrl = URL.createObjectURL(label);
            samples.push(blobUrl);
        }
        return samples;
    }
}